import { render } from "./App.vue?vue&type=template&id=405a16c2"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=405a16c2&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"core/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "405a16c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('405a16c2', __exports__)) {
    api.reload('405a16c2', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=405a16c2", () => {
    api.rerender('405a16c2', render)
  })

}


export default __exports__